import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import MaterialThemeProvider from '@material-ui/styles/ThemeProvider';
import defaultTheme from '../../themes/website';

const ThemeProvider = forwardRef(function ThemeProvider({ theme, children }, ref) {
  return (
    <MaterialThemeProvider theme={theme} ref={ref}>
      {children}
    </MaterialThemeProvider>
  );
});

ThemeProvider.propTypes = {
  theme: Proptypes.shape({
    typography: Proptypes.object, // eslint-disable-line react/forbid-prop-types
    palette: Proptypes.object, // eslint-disable-line react/forbid-prop-types
  }),
  children: Proptypes.node.isRequired,
};

ThemeProvider.defaultProps = {
  theme: defaultTheme,
};

ThemeProvider.displayName = 'ThemeProvider';

export default ThemeProvider;
